import { LoaderIcon } from "./LoaderIcon/LoaderIcon"

export const Preloader = () => {
    return (
        <div className="preloader" style={{
            backgroundImage: `url("/preloaders/preloader_1.png")`, 
            width: '100vw', 
            height: '100vh',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            <LoaderIcon />
        </div>
    )
}